import React, { Component } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col, Card } from 'react-bootstrap'
import Cards from 'react-credit-cards';

import 'react-credit-cards/es/styles-compiled.css';
import axios from 'axios';


interface CardData {
    _id:             string;
    cardToken:       string;
    aliasName:       string;
    redactedNumbers: string;
    expireDate:      string;
    cardAssociation: string;
    cardBankCode:    number;
    cardBankName:    string;
}

function Payment() {

    const history = useHistory();

    const [cards, setCards] = React.useState<CardData[]>([]);

    React.useEffect(() => {
        if (localStorage.getItem('loginToken') === null) {
          history.push('./login');
          return;
        }
        // else {
        //   console.log('Payment Page User Token:',localStorage.getItem('loginToken'))
        //   axios.get('https://liveapi.appac.io/user/cards',{headers:{
        //     'Authorization': `Bearer ${localStorage.getItem('loginToken')}`
        //   }})
        //   .then(function (response) {
        //     // handle success
        //     console.log(response.data);
        //     setCards(response.data as CardData[])
        //   })
        //   .catch(function (error) {
        //     // handle error
        //     console.log(error.response.data.message);
        //   })
        //   .then(function () {
        //     // always executed
        //   });
        
        // }
      }, [])
    return (
        <>
            <Row>
                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title>Kayıtlı Kartlarım</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                {
                                    cards.map(card => {
                                        return (
                                            <Col lg={6} xl={4} sm={12} xs={12} md={6} className={"mb-4"} id={card._id}>
                                                <div className={"customCard clickable"} style={{ ["--img-url" as any]: `url('https://cdn.mekatro.tech/bizlealstore/imagestore/cards/${card.cardBankCode}.svg')` }}>
                                                    <Cards
                                                        cvc={"000"}
                                                        expiry={card.expireDate}
                                                        preview={true}
                                                        issuer={card.cardAssociation === "VISA" ? "visa" : "mastercard"}
                                                        name={card.aliasName}
                                                        number={card.redactedNumbers}
                                                    />
                                                </div>
                                            </Col>
                                        )
                                    })
                                }
                                <Col lg={6} xl={4} sm={12} xs={12} md={6} className={"mb-4"}>
                                <div className={"customCardNew"} onClick={() => history.push("/newPayment")}>

                                </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Payment;